import inliner from 'svg-style-inliner';
const Promise = require('bluebird');
const svgSize = require('./svgSize.js');
const AR = require('component/core/index.js');
const debounce = require('throttle-debounce/debounce');

function getSvg(filename) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: filename,
			dataType: 'html'
		})
			.done(resolve)
			.fail(reject);
	});
}

const triggerResize = debounce(500, () => {
	$(window).trigger('resize');
});

// Выставить размеры svg
function setSvgSize($svg, width, height) {
	if (width) {
		$svg.attr('width', width);

		if (!height) {
			height = svgSize.getFittedSvgSize($svg, width).height;
		}
	}
	if (height) {
		$svg.attr('height', height);
	}
}

// Продублировать параметры размеров в стили (для IE)
function sizeToStyles($elem) {
	let width = $elem.attr('width');
	let height = $elem.attr('height');
	if (Number(width) == width) {
		width = width + 'px';
	}
	if (Number(height) == height) {
		height = height + 'px';
	}

	$elem.css('width', width)
		.css('height', height);
}

function renderSvg() {
	$('[data-svg]')
		.each(function () {
			const $svgDiv = $(this);
			const svgFilename = $svgDiv.attr('data-svg');
			const pngFilename = svgFilename.replace('.svg', '.png');
			if (AR.offline) {
				if (AR.features.svg) {
					$svgDiv.html(`<img src="${svgFilename}" width="100%">`);
				} else {
					$svgDiv.html(`<img src="${pngFilename}" width="100%">`);
				}
			} else {
				if (AR.features.svg) {
					getSvg(svgFilename)
						.then(function (svg) {
							const $svgDiv = $(`[data-svg="${svgFilename}"]`);
							$svgDiv.html(svg);
							const $svg = $svgDiv.find('svg');
							let divWidth = $svgDiv.attr('width');
							let divHeight = $svgDiv.attr('height');
							const isFixed = $svgDiv.attr('data-fixed') === 'true';
							sizeToStyles($svgDiv);

							if (!isFixed) {
								svgSize.fitSvgSizeToWidth($svgDiv, $svg);
							} else {
								setSvgSize($svg, divWidth, divHeight);
							}
							sizeToStyles($svg);

							// Замена font-family, заданных инлайном на значение параметра data-font-family
							const fontFamily = $svgDiv.attr('data-font-family');
							if (fontFamily) {
								$svg.find('*').each(function () {
									if ($(this).attr('font-family')) {
										$(this).attr('font-family', fontFamily);
									}
								});
							}

							if ($svgDiv.attr('data-inline-styles')) {
								inliner($svg[0]);
							}

							return $svg;
						})
						.then($svg => $(window).trigger('svgRendered', [$svg]))
						.then(() => triggerResize())
						.catch(err => console.error(err));
				} else {
					$svgDiv.html(`<img src="${pngFilename}" width="100%">`);
				}
			}
		});
}

renderSvg();

$(window).on('pageUpdate', renderSvg);



// WEBPACK FOOTER //
// ./temp/components/svg/index.js